import { render, staticRenderFns } from "./ReplyToMessage.vue?vue&type=template&id=4ed1d014&scoped=true&"
import script from "./ReplyToMessage.vue?vue&type=script&lang=js&"
export * from "./ReplyToMessage.vue?vue&type=script&lang=js&"
import style0 from "./ReplyToMessage.vue?vue&type=style&index=0&id=4ed1d014&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed1d014",
  null
  
)

export default component.exports